import React from 'react'
import {connect} from 'react-redux'
import {Line} from 'react-chartjs-2';
import HistoryDataProcessor from "../classes/HistoryDataProcessor"
import {setHistoryData, setHistoryRaw} from "../state/actions/app"

const mapStateAsProps = state =>({
    projectInfo: state.projectInfo.projectInfo,
    report: state.projectInfo.report,
    historyData: state.historyData,
    urlParams: state.projectInfo.urlParams
})

const mapDispatchAsProps = dispatch =>({
    setHistoryData: (data) => dispatch(setHistoryData(data)),
    setHistoryRaw: (data) => dispatch(setHistoryRaw(data))
})

const convertDateToLabel = (timestamp, multiline=true) =>{
    const fullDate = new Date(timestamp)
    const date = fullDate.toLocaleDateString()
    const time = fullDate.toLocaleTimeString()
    if(multiline)
        return [date, time]
    else 
        return date+" "+time
}


class HistoryCharts extends React.Component{

    constructor(props){
        super(props)
        this.project = props.projectsController
        this.historyDataProcessor = new HistoryDataProcessor()

        this.displayedHistoryReports=[]

        this.state = {
            security: null,
            stability: null,
            licensing: null
        }

        this.options= {
            tooltips: {
                filter: function(tooltipItem){
                    return tooltipItem.datasetIndex===2 || tooltipItem.datasetIndex===3
                },
                intersect: true,
                mode: "index"
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero:true,
                        includeBounds: true,
                        suggestedMin:0,
                        suggestedMax: 100,
                        stepSize: 5
                    }
                }],
                xAxes: [{
                    ticks: {
                        autoSkip: false,
                        stepSize: 1,
                        fontStyle: "normal",
                        major: {
                            enabled: true,
                            fontStyle: "bold"
                        }
                    }
                }]         
                
            },
            legend:{
                display: false
            },
            responsive: true,
            maintainAspectRatio: false,
            onClick: (event,elements)=>{
                try{
                    const target = event.target.id
                    
                    let element = null
                    for ( const entry of [...elements]) {
                        if ( entry._options.backgroundColor===window.getColor("none") || entry._options.backgroundColor===window.getColor("high")) {
                            element = entry
                            break
                        }
                    }

                    if (! element) { 
                        return null
                    }

                    const xPosition = element._model.x
                    const entryIndex = element._xScale._labelItems.reduce((result, current, index)=>{
                        if(current.x === xPosition){
                            result = index
                        }
                        return result
                    },null)
                    if( entryIndex === null){
                        return null
                    }


                    this.props.setHistoryData({selected: null})
                    let chart = ""
                    if(target ==="security-history") chart = "security"
                    if(target ==="stability-history") chart = "stability"
                    if(target ==="licensing-history") chart = "licensing"
                    this.props.setHistoryData({selected: this.displayedHistoryReports[entryIndex].uuid, chart})
                    window.$("#history-details").modal("toggle")
                    return entryIndex

                }
                catch(er){
                    console.log(er)
                    return null
                }
            },
        }
        this.plugins= [{
            beforeDraw: function({chart}) {

                
                let index = 0;
                
                const selected = props.historyData.selected
                const history = props.historyData.history || []

                const box = chart.boxes.find(box => box.id === "x-axis-0")

                let date = null


                for ( const entry of history ){
                    if (selected === entry.uuid) {
                        date = convertDateToLabel(entry.timestamp, box.ticks.length)
                    }
                } 

                
                const tick = date ? box._ticks.find((tick,i)=>{
                    if (tick.label[0]===date[0] && tick.label[1]===date[1]){
                        index = i;
                    }
                    return tick.label[0]===date[0] && tick.label[1]===date[1]
                }) : box._ticks[box._ticks.length-1]


                if (!date){
                    index = box._ticks.length-1
                }

                if(tick) tick.major = true
                if(box._gridLineItems && box._gridLineItems[index]){
                    box._gridLineItems[index].width=2
                    box._gridLineItems[index].color=window.getColor("greys-2")
                }


            }
        }]
    }

    async getHistoryData(){
        let history =  this.props.historyData.history
        if ( !history ){
            history = await this.project.history(this.props.urlParams.pid, this.props.urlParams.branch)
        }
        const processedData = this.historyDataProcessor.process(history, this.props.report.thresholds)
        this.props.setHistoryData({"processed":processedData})
        this.props.setHistoryRaw(history)
    }


    processChartsData(){

        let history = this.props.historyData.processed

        if (!history) return

        let selectedRangeMax = this.props.selection
        if ( selectedRangeMax === 0 ){
            selectedRangeMax = 5
        }
        if (history.length < selectedRangeMax){
            selectedRangeMax = history.length+1
        }

        history = history.slice(0, selectedRangeMax)

        

        const labels = []
        const securityScoresDataset = {
            type: "line",
            label: "Score",
            data: [],
            backgroundColor: window.getColor("accents-blues-3-alpha-050"),
            borderColor: window.getColor("accents-blues-3-alpha-050"),
            pointBackgroundColor: window.getColor("accents-blues-3-alpha-050"),
            radius: 6
        }
        const securityThresholdsDataset = {
            type: "line",
            label: "Threshold",
            data: [],
            pointBackgroundColor: window.getColor("medium"),
            fill: false,
            borderColor: window.getColor("medium"),
            radius: 6
        }
        const securitySuccessDataset = {
            type: "scatter",
            label: "Success",
            data: [],
            backgroundColor: window.getColor("none"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }
        const securityFailuresDataset = {
            type: "scatter",
            label: "Failure",
            data: [],
            backgroundColor: window.getColor("high"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }

        const stabilityScoresDataset = {
            type: "line",
            label: "Score",
            data: [],
            backgroundColor: window.getColor("accents-blues-3-alpha-050"),
            borderColor: window.getColor("accents-blues-3-alpha-050"),
            pointBackgroundColor: window.getColor("accents-blues-3-alpha-050"),
            radius: 6
        }
        const stabilityThresholdsDataset = {
            type: "line",
            label: "Threshold",
            data: [],
            pointBackgroundColor: window.getColor("medium"),
            fill: false,
            borderColor: window.getColor("medium"),
            radius: 6
        }
        const stabilitySuccessDataset = {
            type: "scatter",
            label: "Success",
            data: [],
            backgroundColor: window.getColor("none"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }
        const stabilityFailuresDataset = {
            type: "scatter",
            label: "Failure",
            data: [],
            backgroundColor: window.getColor("high"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }

        const licensingScoresDataset = {
            type: "line",
            label: "Score",
            data: [],
            backgroundColor: window.getColor("accents-blues-3-alpha-050"),
            borderColor: window.getColor("accents-blues-3-alpha-050"),
            pointBackgroundColor: window.getColor("accents-blues-3-alpha-050"),
            radius: 6
        }
        const licensingThresholdsDataset = {
            type: "line",
            label: "Threshold",
            data: [],
            pointBackgroundColor: window.getColor("medium"),
            fill: false,
            borderColor: window.getColor("medium"),
            radius: 6
        }
        const licensingSuccessDataset = {
            type: "scatter",
            label: "Success",
            data: [],
            backgroundColor: window.getColor("none"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }
        const licensingFailuresDataset = {
            type: "scatter",
            label: "Failure",
            data: [],
            backgroundColor: window.getColor("high"),
            pointStyle: "circle",
            radius: 6,
            spanGaps: true
        }

        let j = 0


        this.displayedHistoryReports = []
        for ( let i = history.length-1; i>=0; i-- ){
            const entry = history[i]
            const label = convertDateToLabel(entry.timestamp, history.length <= 10)
            labels.push(label)
            this.displayedHistoryReports.push(entry)
            securityScoresDataset.data.push(entry.security)
            securityThresholdsDataset.data.push(entry.minSecurityScore)
            stabilityScoresDataset.data.push(entry.stability)
            stabilityThresholdsDataset.data.push(entry.minStabilityScore)
            licensingScoresDataset.data.push(entry.licensing)
            licensingThresholdsDataset.data.push(entry.minLicensingScore)

            
            if (entry.security < entry.minSecurityScore) {
                securityFailuresDataset.data.push({x: j, y: entry.security})
                securitySuccessDataset.data.push(null)
            }
            else{
                securitySuccessDataset.data.push({x: j, y: entry.security})
                securityFailuresDataset.data.push(null)
            }
            if (entry.stability < entry.minStabilityScore) {
                stabilityFailuresDataset.data.push({x: j, y: entry.stability})
                stabilitySuccessDataset.data.push(null)
            }
            else{
                stabilityFailuresDataset.data.push(null)
                stabilitySuccessDataset.data.push({x: j, y: entry.stability})
            }
            if (entry.licensing < entry.minLicensingScore) {
                licensingFailuresDataset.data.push({x: j, y: entry.licensing})
                licensingSuccessDataset.data.push(null)
            }
            else{
                licensingSuccessDataset.data.push({x: j, y: entry.licensing})
                licensingFailuresDataset.data.push(null)
            }
            j++

        }


        const security = {
            data:{
                labels,
                datasets: [
                    securitySuccessDataset, securityFailuresDataset, securityScoresDataset, securityThresholdsDataset
                ]
            }
        }

        const stability = {
            data:{
                labels,
                datasets: [
                    stabilitySuccessDataset, stabilityFailuresDataset, stabilityScoresDataset, stabilityThresholdsDataset
                ]
            }
        }

        const licensing = {
            data:{
                labels,
                datasets: [
                    licensingSuccessDataset, licensingFailuresDataset, licensingScoresDataset, licensingThresholdsDataset
                ]
            }
        }

        this.setState({
            security, stability, licensing
        })
    }

    componentDidMount(){

        this.getHistoryData()
        .then(()=>{
            this.processChartsData()
        })
    }

    getSnapshotBeforeUpdate(prevProps){
        return prevProps.selection !== this.props.selection || prevProps.historyData.selection !== this.props.historyData.selection
    }

    componentDidUpdate(prevProps,prevState,didUpdate){
        if ( ! didUpdate ) return  
        this.processChartsData()
        
    }

    render(){

        
        return <div className="row pt-3 col-md-12">
            { this.state.security? <div className="col-md-4 history-chart">
                    <p className="text-center"><b>Security history</b></p>
                    <Line id="security-history" data={this.state.security.data} height={350} options={this.options} plugins={this.plugins}/> 
                </div> : "" }
            { this.state.stability? <div className="col-md-4 history-chart">
                    <p className="text-center"><b>Stability history</b></p>
                    <Line id="stability-history" data={this.state.stability.data} options={this.options} plugins={this.plugins}/>
                </div>: "" }
            { this.state.licensing? <div className="col-md-4 history-chart">
                    <p className="text-center"><b>Licensing history</b></p>
                    <Line id="licensing-history" data={this.state.licensing.data} options={this.options} plugins={this.plugins}/>
                </div>: "" }
        </div>
            
              
              

    }

}


export default connect(mapStateAsProps, mapDispatchAsProps)(HistoryCharts)